import gql from "graphql-tag";

export default gql`
  mutation StopEvent($customerId: ID, $eventId: ID) {
    stopEvent(customerId: $customerId, eventId: $eventId) {
      id
      customerId
    }
  }
`;
